import { render } from "./addModuleGoodsManage.vue?vue&type=template&id=16dfc573&scoped=true"
import script from "./addModuleGoodsManage.vue?vue&type=script&lang=js"
export * from "./addModuleGoodsManage.vue?vue&type=script&lang=js"

import "./addModuleGoodsManage.vue?vue&type=style&index=0&id=16dfc573&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16dfc573"]])

export default __exports__